import React, {memo, useCallback, useState,} from "react";
import {useTranslation} from "react-i18next";
import {CustomOverlay} from "@delivus-daas/react-open-layers";
import {Button} from "shared/ui";
import {TooltipSvg} from "../../../../shared/assets/svgs/TooltipSvg";
import {PlansTooltip} from "./PlansTooltip";
import {TShippingTooltip} from "../../../../shared/types";
import {IShippingWithCluster} from "../../types";

interface Props {
  shippingTooltip?: TShippingTooltip<IShippingWithCluster>;
}

export const ToolButton = memo(({
                                  shippingTooltip
                                }: Props) => {
  const {t} = useTranslation(["shipping"]);
  const [isVisibleTooltip, setIsVisibleTooltip] = useState(true);
  const toggleTooltip = useCallback(() => {
    setIsVisibleTooltip((prev) => !prev);
  }, []);
  
  return (<Button
    variant={"primary"}
    size={"sm"}
    className={"button " + isVisibleTooltip}
    onClick={toggleTooltip}
  >
    <TooltipSvg color={isVisibleTooltip ? "white" : "black"} />
    {t("tooltip")}
    
    <CustomOverlay
      id={"shipping-tooltip"}
      className={"tooltip"}
      visible={isVisibleTooltip}
      position={shippingTooltip?.position}
    >
      <PlansTooltip shippings={shippingTooltip?.shippings} />
    </CustomOverlay>
  </Button>);
});
